module.exports = __webpack_public_path__ + "fonts/ubuntu-v14-latin-regular.ec687cb.eot";